import axios from 'axios';

const csrfToken = () => document.getElementsByName('csrf-token')[0]?.content;

const requestConfig = (method, url, { data = undefined, params = undefined } = {}) => ({
  method,
  url,
  data,
  params,
  headers: {
    'X-CSRF-Token': csrfToken(),
  },
});

export const fetchCallFollowUp = async (id) => {
  const response = await axios(requestConfig('GET', `/api/v1/call_followups/${id}`));
  return response.data?.call_followup;
};

export const createCallFollowUp = async (payload) => {
  const response = await axios(requestConfig('POST', '/api/v1/call_followups', { data: { call_followup: payload } }));
  return response.data?.call_followup;
};

export const updateCallFollowUp = async (id, payload) => {
  const response = await axios(requestConfig('PATCH', `/api/v1/call_followups/${id}`, { data: { call_followup: payload } }));
  return response.data?.call_followup;
};

export const addCallFollowUpEntry = async (callFollowUpId, payload) => {
  const response = await axios(requestConfig(
    'POST',
    `/api/v1/call_followups/${callFollowUpId}/entries`,
    { data: { call_followup_entry: payload } },
  ));
  return response.data?.call_followup;
};

export const fetchCallFollowUps = async (params = {}) => {
  const response = await axios(requestConfig('GET', '/api/v1/call_followups', { params }));
  return {
    call_followups: response.data?.call_followups || [],
    meta: response.data?.meta || {},
  };
};

export const fetchCallFollowUpOptions = async (params = {}) => {
  const response = await axios(requestConfig('GET', '/api/v1/call_followups/options', { params }));
  return response.data;
};

export const fetchCallFollowUpQueueOptions = async (params = {}) => (
  fetchCallFollowUpOptions({
    include_assignees: true,
    ...params,
  })
);
